import { Flex } from "@chakra-ui/react";
import { TipoDestinoEnum } from "core/features/documentos/enums/index";
import { MensagemOrigem } from "core/features/mensagens/typings";
import colors from "core/resources/theme/colors";
import SelectableButton from "ui/components/Button/SelectableButton";
import ListingPageHeaderBar from "ui/components/Page/ListingPageHeaderBar";
export interface HeaderTableProps {
  onSearch: (q?: string) => void;
  value: string;
  mensagensRespondidas?: boolean;
  onSelectMensagensRespondidas?: (type?: boolean) => any;
  showTag?: boolean;
  date?: { dataInicio?: string; dataFim?: string };
  onChangeOrder: (
    changeValue: "orderBy" | "orderDirection",
    value?: "ASC" | "DESC" | string
  ) => void;
  onSelectPortaria: (type: boolean) => void;
  isPortaria?: boolean;
  orderBy?: string;
  orderDirection?: "ASC" | "DESC";
  destino?: TipoDestinoEnum;
  origem: MensagemOrigem;
  setIsOpenModalFiltros: (v: boolean) => void;
}

function HeaderTable({
  onSearch,
  value,
  mensagensRespondidas,
  onSelectMensagensRespondidas,
  showTag = true,
  date,
  onChangeOrder,
  onSelectPortaria,
  isPortaria,
  orderBy,
  orderDirection,
  destino,
  origem,
  setIsOpenModalFiltros,
}: HeaderTableProps) {
  const onSelectRespondidas = () => onSelectMensagensRespondidas?.(true);
  const onSelectNaoRespondidas = () => onSelectMensagensRespondidas?.(false);
  const onUnselect = () => onSelectMensagensRespondidas?.();

  const getOrdenacaoOptions = () => {
    const ordenacaoOptions = [
      {
        value: "createdAt",
        label: "Criação",
      },

      {
        value: "assunto",
        label: "Assunto",
      },
      {
        value: "autor",
        label: "Autor",
      },
    ];

    if ([MensagemOrigem.Recebida, MensagemOrigem.Arquivada].includes(origem)) {
      ordenacaoOptions.push({
        value: "unidade",
        label: "Unidade",
      });
    }

    return ordenacaoOptions;
  };

  return (
    <>
      <ListingPageHeaderBar
        valueSearch={value as any}
        onSearch={(v?: string) => onSearch(v)}
        visibleFiltro
        searchMaxWidth="340px"
        badge
        badgeValue={
          [!!date?.dataFim || !!date?.dataInicio, destino].filter(Boolean)
            .length
        }
        onFiltro={() => setIsOpenModalFiltros(true)}
        children={
          <Flex flex={1} alignItems="center">
            <Flex gridGap="16px">
              {showTag ? (
                <>
                  <SelectableButton
                    selected={mensagensRespondidas === true}
                    onClick={onSelectRespondidas}
                    onUnselect={onUnselect}
                    rounded="full"
                    selectedColor={colors.green500}
                    fontSize="14px"
                  >
                    Respondidas
                  </SelectableButton>
                  <SelectableButton
                    selected={mensagensRespondidas === false}
                    onClick={onSelectNaoRespondidas}
                    onUnselect={onUnselect}
                    rounded="full"
                    selectedColor={colors.red500}
                    fontSize="14px"
                  >
                    Não respondidas
                  </SelectableButton>

                  <SelectableButton
                    selected={isPortaria!}
                    onClick={() => onSelectPortaria(true)}
                    onUnselect={() => onSelectPortaria(false)}
                    rounded="full"
                    selectedColor={colors.blue600}
                    fontSize="14px"
                  >
                    Portaria
                  </SelectableButton>
                </>
              ) : null}
            </Flex>
          </Flex>
        }
        showOrderByButton
        orderByOptions={getOrdenacaoOptions()}
        orderBy={orderBy}
        onOrderByChange={(v) => onChangeOrder("orderBy", v)}
        orderDirection={orderDirection}
        onOrderDirectionChange={(v) =>
          onChangeOrder("orderDirection", v as "ASC" | "DESC")
        }
      />
    </>
  );
}

export default HeaderTable;
